import * as Crypto from 'expo-crypto';
import {CreateInviteLinkRequest, CreateInviteLinkResponse, InvitationType} from '@shared/models/invitation';
import React, {useEffect, useMemo} from 'react';
import ShareButton from '@ui/components/buttons/ShareButton';
import {TeamUiData} from '@shared/models/team';
import useCallable from '@ui/hooks/useCallable';
import {useTeamOpenInvitation} from '@ui/features/invitation/hooks/invitation-hooks';
import {useTranslation} from 'react-i18next';
import {useUser} from '@ui/provider/user/UserProvider';

interface Props {
    team: TeamUiData;
}

const TeamInvitePlayers = (props: Props) => {
    const {team} = props;
    const {user} = useUser();
    const {t} = useTranslation();
    const [teamInvitation, teamInvitationLoading] = useTeamOpenInvitation(user!.uid, team.id);
    const [createInvitationWithLink, isLoading] = useCallable<CreateInviteLinkRequest, CreateInviteLinkResponse>('invitation-createWithLink');
    const id = useMemo(() => Crypto.randomUUID(), []);

    useEffect(() => {
        if((!teamInvitation || teamInvitation.length === 0) && !teamInvitationLoading) {
            createInvitationWithLink({
                id,
                teamId: team.id,
                type: InvitationType.Team,
            });
        }
    }, [teamInvitation, teamInvitationLoading]);

    return (
        <ShareButton
            url={teamInvitation?.[0]?.link}
            text={t('invitation.actions.shareLink')}
            message={t('invitation.shareMessage', {name: team.username})}
            size='lg'
            _button={{isLoading: isLoading || teamInvitationLoading}}
            type='team_invite'
        />
    );
};

export default TeamInvitePlayers;
